import { Page } from "$components/page";
import { Box } from "@material-ui/core";
import { Content } from "./_internal/content";
import { Header } from "./_internal/header";

export const UnauthorizedPage = () => (
  <Page>
    <Header />
    <Box flex={1} display="flex" alignItems="center">
      <Content />
    </Box>
  </Page>
);
